import { render, staticRenderFns } from "./TopPages.vue?vue&type=template&id=dad50498&"
import script from "./TopPages.vue?vue&type=script&lang=js&"
export * from "./TopPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports